<!-- <div class="layer-1 shadow"></div> -->

<div class="wrapper">
  <div class="composition">
    <div style="width: 100%;" class="text-center">
      <h1 class="letters">Página no encontrada</h1>
    </div>
    <div class="layer-0 shelf">
      <div class="shelf__side_left"></div>
      <div class="shelf__side_bottom"></div>

      <div class="case case_1">
        <div class="case__front"></div>
        <div class="case__top"></div>
        <div class="case__label case__label_right"></div>
        <div class="case__right"></div>
        <div class="case__number">
          №2428506
        </div>
      </div>
      <div class="case case_2">
        <div class="case__front"></div>
        <div class="case__top"></div>
        <div class="case__label case__label_left"></div>
        <div class="case__right"></div>
        <div class="case__number">
          №2428506
        </div>
      </div>
      <div class="case case_3">
        <div class="case__front"></div>
        <div class="case__top"></div>
        <div class="case__label case__label_right"></div>
        <div class="case__right"></div>
        <div class="case__number">
          №2428506
        </div>
      </div>
      <div class="case case_4">
        <div class="case__front"></div>
        <div class="case__top"></div>
        <div class="case__label case__label_left"></div>
        <div class="case__right"></div>
        <div class="case__number">
          №2428506
        </div>
      </div>
      <div class="case case_5">
        <div class="case__front"></div>
        <div class="case__top"></div>
        <div class="case__label case__label_left"></div>
        <div class="case__right"></div>
        <div class="case__number">
          №2428506
        </div>
      </div>
      <div class="case case_6">
        <div class="case__front"></div>
        <div class="case__top"></div>
        <div class="case__label case__label_right"></div>
        <div class="case__right"></div>
        <div class="case__number">
          №2428506
        </div>
      </div>
      <div class="case case_7">
        <div class="case__front"></div>
        <div class="case__top"></div>
        <div class="case__label case__label_left"></div>
        <div class="case__right"></div>
        <div class="case__number">
          №2428506
        </div>
      </div>
      <div class="case case_8">
        <div class="case__front"></div>
        <div class="case__top"></div>
        <div class="case__label case__label_left"></div>
        <div class="case__right"></div>
        <div class="case__number">
          №2428506
        </div>
      </div>
      <div class="case case_9">
        <div class="case__front"></div>
        <div class="case__top"></div>
        <div class="case__label case__label_left"></div>
        <div class="case__right"></div>
        <div class="case__number">
          №2428506
        </div>
      </div>
      <div class="case case_10">
        <div class="case__front"></div>
        <div class="case__top"></div>
        <div class="case__label case__label_left"></div>
        <div class="case__right"></div>
        <div class="case__number">
          №2428506
        </div>
      </div>
      <div class="case case_11">
        <div class="case__front"></div>
        <div class="case__top"></div>
        <div class="case__label case__label_left"></div>
        <div class="case__right"></div>
        <div class="case__number">
          №2428506
        </div>
      </div>
      <div class="case case_12">
        <div class="case__front"></div>
        <div class="case__top"></div>
        <div class="case__label case__label_left"></div>
        <div class="case__right"></div>
        <div class="case__number">
          №2428506
        </div>
      </div>
      <div class="case case_13">
        <div class="case__front"></div>
        <div class="case__top"></div>
        <div class="case__label case__label_left"></div>
        <div class="case__right"></div>
        <div class="case__number">
          №2428506
        </div>
      </div>
      <div class="case case_14">
        <div class="case__front"></div>
        <div class="case__top"></div>
        <div class="case__label case__label_left"></div>
        <div class="case__right"></div>
        <div class="case__number">
          №2428506
        </div>
      </div>
      <div class="case case_15">
        <div class="case__front"></div>
        <div class="case__top"></div>
        <div class="case__label case__label_right"></div>
        <div class="case__right"></div>
        <div class="case__number">
          №2428506
        </div>
      </div>
      <div class="case case_16">
        <div class="case__front"></div>
        <div class="case__top"></div>
        <div class="case__label case__label_left"></div>
        <div class="case__right"></div>
        <div class="case__number">
          №2428506
        </div>
      </div>
      <div class="case case_17">
        <div class="case__front"></div>
        <div class="case__top"></div>
        <div class="case__label case__label_right"></div>
        <div class="case__right"></div>
        <div class="case__number">
          №2428506
        </div>
      </div>
      <div class="case case_18">
        <div class="case__front"></div>
        <div class="case__top"></div>
        <div class="case__label case__label_left"></div>
        <div class="case__right"></div>
        <div class="case__number">
          №2428506
        </div>
      </div>
      <div class="case case_19">
        <div class="case__front"></div>
        <div class="case__top"></div>
        <div class="case__label case__label_right"></div>
        <div class="case__right"></div>
        <div class="case__number">
          №2428506
        </div>
      </div>
      <div class="case case_20">
        <div class="case__front"></div>
        <div class="case__top"></div>
        <div class="case__label case__label_right"></div>
        <div class="case__right"></div>
        <div class="case__number">
          №2428506
        </div>
      </div>
      <div class="case case_21">
        <div class="case__front"></div>
        <div class="case__top"></div>
        <div class="case__label case__label_left"></div>
        <div class="case__right"></div>
        <div class="case__number">
          №2428506
        </div>
      </div>
      <div class="case case_22">
        <div class="case__front"></div>
        <div class="case__top"></div>
        <div class="case__label case__label_right"></div>
        <div class="case__right"></div>
        <div class="case__number">
          №2428506
        </div>
      </div>
      <div class="case case_23">
        <div class="case__front"></div>
        <div class="case__top"></div>
        <div class="case__label case__label_left"></div>
        <div class="case__right"></div>
        <div class="case__number">
          №2428506
        </div>
      </div>
      <div class="case case_24">
        <div class="case__front"></div>
        <div class="case__top"></div>
        <div class="case__label case__label_right"></div>
        <div class="case__right"></div>
        <div class="case__number">
          №2428506
        </div>
      </div>
      <div class="case case_25">
        <div class="case__front"></div>
        <div class="case__top"></div>
        <div class="case__label case__label_left"></div>
        <div class="case__right"></div>
        <div class="case__number">
          №2428506
        </div>
      </div>
      <div class="case case_26">
        <div class="case__front"></div>
        <div class="case__top"></div>
        <div class="case__label case__label_right"></div>
        <div class="case__right"></div>
        <div class="case__number">
          №2428506
        </div>
      </div>
      <div class="case case_27">
        <div class="case__front"></div>
        <div class="case__top"></div>
        <div class="case__label case__label_right"></div>
        <div class="case__right"></div>
        <div class="case__number">
          №2428506
        </div>
      </div>
      <div class="case case_28">
        <div class="case__front"></div>
        <div class="case__top"></div>
        <div class="case__label case__label_left"></div>
        <div class="case__right"></div>
        <div class="case__number">
          №2428506
        </div>
      </div>
      <div class="case case_29">
        <div class="case__front"></div>
        <div class="case__top"></div>
        <div class="case__label case__label_left"></div>
        <div class="case__right"></div>
        <div class="case__number">
          №2428506
        </div>
      </div>
      <div class="case case_30">
        <div class="case__front"></div>
        <div class="case__top"></div>
        <div class="case__label case__label_left"></div>
        <div class="case__right"></div>
        <div class="case__number">
          №2428506
        </div>
      </div>
      <div class="case case_31">
        <div class="case__front"></div>
        <div class="case__top"></div>
        <div class="case__label case__label_right"></div>
        <div class="case__right"></div>
        <div class="case__number">
          №2428506
        </div>
      </div>
      <div class="case case_32">
        <div class="case__front"></div>
        <div class="case__top"></div>
        <div class="case__label case__label_left"></div>
        <div class="case__right"></div>
        <div class="case__number">
          №2428506
        </div>
      </div>
      <div class="case case_33">
        <div class="case__front"></div>
        <div class="case__top"></div>
        <div class="case__label case__label_right"></div>
        <div class="case__right"></div>
        <div class="case__number">
          №2428506
        </div>
      </div>
      <div class="case case_34">
        <div class="case__front"></div>
        <div class="case__top"></div>
        <div class="case__label case__label_right"></div>
        <div class="case__right"></div>
        <div class="case__number">
          №2428506
        </div>
      </div>
      <div class="case case_35">
        <div class="case__front"></div>
        <div class="case__top"></div>
        <div class="case__label case__label_left"></div>
        <div class="case__right"></div>
        <div class="case__number">
          №2428506
        </div>
      </div>
      <div class="case case_36">
        <div class="case__front"></div>
        <div class="case__top"></div>
        <div class="case__label case__label_right"></div>
        <div class="case__right"></div>
        <div class="case__number">
          №2428506
        </div>
      </div>
      <div class="case case_37">
        <div class="case__front"></div>
        <div class="case__top"></div>
        <div class="case__label case__label_left"></div>
        <div class="case__right"></div>
        <div class="case__number">
          №2428506
        </div>
      </div>
      <div class="case case_38">
        <div class="case__front"></div>
        <div class="case__top"></div>
        <div class="case__label case__label_right"></div>
        <div class="case__right"></div>
        <div class="case__number">
          №2428506
        </div>
      </div>
      <div class="case case_39">
        <div class="case__front"></div>
        <div class="case__top"></div>
        <div class="case__label case__label_left"></div>
        <div class="case__right"></div>
        <div class="case__number">
          №2428506
        </div>
      </div>
      <div class="case case_40">
        <div class="case__front"></div>
        <div class="case__top"></div>
        <div class="case__label case__label_right"></div>
        <div class="case__right"></div>
        <div class="case__number">
          №2428506
        </div>
      </div>
      <div class="case case_41">
        <div class="case__front"></div>
        <div class="case__top"></div>
        <div class="case__label case__label_left"></div>
        <div class="case__right"></div>
        <div class="case__number">
          №2428506
        </div>
      </div>
      <div class="case case_42">
        <div class="case__front"></div>
        <div class="case__top"></div>
        <div class="case__label case__label_right"></div>
        <div class="case__right"></div>
        <div class="case__number">
          №2428506
        </div>
      </div>
      <div class="case case_43">
        <div class="case__front"></div>
        <div class="case__top"></div>
        <div class="case__label case__label_left"></div>
        <div class="case__right"></div>
        <div class="case__number">
          №2428506
        </div>
      </div>
      <div class="case case_44">
        <div class="case__front"></div>
        <div class="case__top"></div>
        <div class="case__label case__label_right"></div>
        <div class="case__right"></div>
        <div class="case__number">
          №2428506
        </div>
      </div>
      <div class="case case_45">
        <div class="case__front"></div>
        <div class="case__top"></div>
        <div class="case__label case__label_left"></div>
        <div class="case__right"></div>
        <div class="case__number">
          №2428506
        </div>
      </div>
      <div class="case case_46">
        <div class="case__front"></div>
        <div class="case__top"></div>
        <div class="case__label case__label_right"></div>
        <div class="case__right"></div>
        <div class="case__number">
          №2428506
        </div>
      </div>
      <div class="case case_47">
        <div class="case__front"></div>
        <div class="case__top"></div>
        <div class="case__label case__label_left"></div>
        <div class="case__right"></div>
        <div class="case__number">
          №2428506
        </div>
      </div>

      <div class="glow">
        <div class="glow__bottom"></div>
        <div class="glow__top"></div>
        <div class="glow__ball glow__ball_1"></div>
        <div class="glow__ball glow__ball_2"></div>
        <div class="glow__ball glow__ball_3"></div>
        <div class="glow__ball glow__ball_4"></div>
        <div class="glow__ball glow__ball_5"></div>
        <div class="glow__ball glow__ball_6"></div>
        <div class="glow__ball glow__ball_7"></div>
        <div class="glow__ball glow__ball_8"></div>
        <div class="glow__ball glow__ball_9"></div>
        <div class="glow__ball glow__ball_10"></div>

      </div>

      <div class="shelf__side_front"></div>
      <div class="shelf__side_right"></div>

      <div class="shelf__handle_top"></div>
      <div class="shelf__handle_front"></div>
      <div class="shelf__handle_right"></div>
    </div>
    <div class="layer-2 numbers">
      <div class="numbers__item numbers__item_1">4</div>
      <div class="numbers__item numbers__item_2">0</div>
      <div class="numbers__item numbers__item_3">4</div>
    </div>
    <div style="width: 100%;" class="text-center button">
        <button mat-raised-button (click)="inicio()">Volver</button>
    </div>
  </div>
</div>
